import React from "react"
import {StaticQuery, graphql} from "gatsby"
import Img from "gatsby-image"
import ArrowImage from "./ArrowImage";

const HboGoImage = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "portfolio/hbo.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data =>
      <figure className="img-figure">
        <Img className="portfolio-img hbo-go-img" fluid={data.placeholderImage.childImageSharp.fluid}
             alt="hbo-go"/>
        <figcaption>
          <h1 className="title">HBO GO streaming platform development</h1>
          <a className="button is-primary is-outlined is-rounded"
             href="https://hbogo.hu/"
             target="_blank"
             rel="noopener noreferrer">
            <span>Visit Website</span>
            <span
              className="icon">
                <ArrowImage/>
                </span>
          </a>
        </figcaption>
        <div className="overlay"/>
      </figure>
    }
  />
)
export default HboGoImage
